<template>
  <div class="card">
    <div class="card-header">
      <h4>Hub Affiliations <span class="h4-icon"><i class="fa fa-sitemap"></i></span></h4>
    </div>
    <div class="card-body">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="mt-2 flex-grow-1 pr-2">
          <b>Project Affiliation Requests</b>
          <font-awesome-icon icon="question-circle" id="affiliation-info"/>
          <b-form-checkbox
            v-model="organizationVuex && organizationVuex.approveAffiliation"
            :value=true
            :unchecked-value=false
            switch
            size="lg">
            <span>Affiliation requests {{
                organizationVuex.approveAffiliation ? ' require approval' : ' do not require approval'
              }}</span>
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="mt-2 flex-grow-1 pr-2">
          <i class="fa fa-hourglass fa-lg"></i>
            <b class="ml-2">Pending Affiliation Requests</b>
          <font-awesome-icon icon="question-circle" id="pending-info"/>
          <div class="row">
            <div class="list-group" v-if="pending && Object.keys(pending).length > 0">
              <div class="list-group-item" v-for="request in pending" :key="request.id">
                <div class="row">
                  <div class="col-md-12">
                    <router-link class="font-weight-bold" title="Visit the Project Page (opens in a new tab)"
                                 :to="{ name: 'ProjectShow', params: { id: request.project.urlField }}" target="_blank" rel="noopener noreferrer">
                      <b>{{ request.project.name }}</b>
                    </router-link>
                  </div>
                  <div class="col-md-6">
                    <b-btn class="primary" size="sm" @click="handleRequest(request, true)">Approve</b-btn>&nbsp;
                    <b-btn variant="danger" size="sm" @click="handleRequest(request, false)">Deny</b-btn>&nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="row ml-4 mt-3"><b>No Pending Requests</b></div>
          </div>
        </div>
      </div>
    </div>
    <b-tooltip target="affiliation-info" placement="bottom">
      Choose whether affiliation requests from projects need approval or not.
    </b-tooltip>
    <b-tooltip target="pending-info" placement="bottom">
      Click approve or deny for pending requests.
    </b-tooltip>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
  name: 'HubAffiliations',
  data() {
    return {}
  },
  created() {
    if (this.organizationVuex && !this.allOrgProjects) {
      this.orgProjects('organizations')
    }
  },
  computed: {
    ...mapGetters({
      organizationVuex: "organization/get/organization",
      allOrgProjects: "organization_projects/get/orgProjects",
      isLoading: "organization_projects/get/isLoading",
      pending: "organization_projects/get/pending",
      approved: "organization_projects/get/approved",
      denied: "organization_projects/get/denied",
    })
  },
  methods: {
    ...mapActions({
      orgProjects: "organization_projects/get/get",
      approveDenyAffiliation: "organization_projects/get/approveDenyAffiliation"
    }),
    handleRequest(request, bApproveDeny) {
      this.approveDenyAffiliation({id: request.id, approveDeny: bApproveDeny})
    },
    // removeAffiliation(id) {
    //
    // },
    // contactProjectManager(id) {
    //
    // },
  },
}

</script>

<style scoped lang="scss"></style>
